import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

export default function Denied() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center" data-testid="access-denied">
      <span className="h-16 w-16 rounded-2xl bg-red-500/10 border border-red-500/30 flex items-center justify-center mb-5">
        <ShieldAlert size={30} className="text-red-400" />
      </span>
      <h1 className="text-2xl font-display font-extrabold text-white">Acesso negado</h1>
      <p className="text-zinc-400 mt-2 max-w-sm">Você não tem permissão para acessar este módulo. Fale com um administrador se precisar de acesso.</p>
      <Link to="/app" className="mt-6 text-sm font-semibold text-black px-5 py-2.5 rounded-full" style={{ background: "linear-gradient(135deg,#F3C64F,#D4AF37 55%,#AA820A)" }}>Voltar ao Dashboard</Link>
    </div>
  );
}
